/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../higherOrderComponents/requests';
import { homepage } from "../../../config";

export default connectRequests((state) => ({
  localizations: {
    url: '/localizations?locale=' + state.localePicker,
    onLoad: true,
    onUpdate: true
  },
  defaultLocalizations: {
    url: '/localizations?locale=' + homepage.default_locale,
    onLoad: (state.localePicker === homepage.default_locale)? false: true,
    onUpdate: (state.localePicker === homepage.default_locale)? false: true
  },
  locales: {
    url: '/locales',
    onLoad: true,

  },
  products: {
    url: '/products?isActive=true',
    onLoad: true,
  },
  generalMessages: {
    url: `/generalMessages`,
    onLoad: true,
  },
}));
